<template>
  <Overlay :show="show">
    <div class="wrapper" @click.stop>
      <div class="block">
        <span class="close" @click="close">取消</span>

        <!-- //选择免费拿主体 -->
        <div class="freegoods-container">
          <div class="banner">
            <div class="banner-detail">
              <div
                class="avatar"
                :style="{ backgroundImage: 'url(' + data.good.goodsImg + ')' }"
                v-if="data && data.good && data.good.goodsImg"
              ></div>
              <div class="title">
                <div class="tit van-multi-ellipsis--l2">
                  {{ data && data.good && data.good.goodsName }}
                </div>
                <div class="amount">
                  <span class="prefix">¥</span>
                  <span class="value">{{ data.actPrice }} </span>
                  <!-- 划线价不要 -->
                  <!-- <span class="unline">¥300</span> -->
                </div>
              </div>
            </div>
            <div class="progress-wrapper">
              <div
                class="tip"
                :style="{
                  marginLeft:
                    data && data.actPrice
                      ? (targetPrice / data.actPrice) * 100 + '%'
                      : null,
                }"
              >
                <span
                  >差¥{{
                    data && data.actPrice ? data.actPrice - targetPrice : ''
                  }}</span
                >
                <span class="tip-arr"></span>
              </div>
              <Progress
                class="progress"
                :percentage="
                  data && data.actPrice
                    ? (targetPrice / data.actPrice) * 100
                    : ''
                "
                pivot-text="0"
                color="#f7b500"
                ref="Progress"
              />
            </div>
            <div class="btn cut-btn" @click="confirmFreeTake">
              确认立即免费拿
            </div>
          </div>
        </div>
      </div>
    </div>
  </Overlay>
</template>

<script>
import { Overlay, Progress } from 'vant'

export default {
  components: { Overlay, Progress },
  data() {
    return {
      show: false,
      data: {},
      targetPrice: null,
    }
  },
  created() {
    // console.log(1)
  },

  updated() {
    //让进度条重绘 才能显示进度
    this.$refs.Progress.resize()
  },

  methods: {
    open(data, targetPrice) {

      this.show = true
      this.data = data
      this.targetPrice = targetPrice
    },
    close() {
      this.show = false
    },
    confirmFreeTake() {
      this.$emit('confirmFreeTake')
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
.van-overlay {
  z-index: 99;
  text-align: center;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    position: relative;
    width: 726px;
    height: 898px;
    margin: 0 auto;
    .close {
      position: absolute;
      display: inline-block;
      padding: 10px 20px;
      font-size: 26px;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      right: 20px;
      top: -60px;
    }

    .freegoods-container {
      .banner {
        position: relative;
        height: 707px;
        background-image: url('~@/assets/activityplace/confirmFreeTake.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        padding-top: 20px;
        .banner-detail {
          display: flex;
          width: 530px;
          margin: 0 auto;
          text-align: left;
          .avatar {
            width: 140px;
            height: 140px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            border-radius: 12px;
            box-shadow: 0 0 1px #eeeeee;
          }
          .title {
            flex: 1;
            min-width: 0;
            padding-left: 20px;
            .tit {
              font-size: 24px;
              font-weight: 600;
              color: #333333;
              line-height: 34px;
              height: 68px;
            }
          }
          .amount {
            padding-top: 44px;
            display: flex;
            align-items: flex-end;
            .prefix {
              font-size: 24px;
              line-height: 1em;
              font-weight: 800;
              color: #e82035;
            }
            .value {
              font-size: 36px;
              line-height: 1em;
              font-weight: 800;
              color: #e82035;
            }
            //暂时不要
            // .unline {
            //   font-size: 20px;
            //   color: #808080;
            //   line-height: 1em;
            //   line-height: 24px;
            //   text-decoration: line-through;
            //   margin-left: 8px;
            // }
          }
        }
        .progress-wrapper {
          width: 480px;
          margin: 0 auto;
          padding-top: 0px;
          text-align: left;
          .tip {
            position: relative;
            display: inline-block;
            margin-left: 0;
            transform: translateX(-50%);
            background-color: #ffd768;
            padding: 12px 14px;
            font-size: 18px;
            font-weight: 600;
            color: #e82035;
            line-height: 18px;
            border-radius: 8px;
            border: 0.5px solid red;
            white-space: nowrap;
            .tip-arr {
              position: absolute;
              bottom: -8.5px;
              height: 18px;
              width: 18px;
              background-color: inherit;
              border: inherit;
              border-top-color: #ffd768;
              left: calc(50% - 10px);
              clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
              transform: rotate(-45deg);
              // ---end---
              border-radius: 0 0 0 2px;
            }
          }
          .progress {
            margin-top: 14px;
            background: #e0e0e0;
            height: 26px;
            border-radius: 13px;
            & /deep/ .van-progress__portion .van-progress__pivot {
              display: none;
              width: 32px;
              height: 32px;
              min-width: 32px;
              color: #fa6400;
            }
          }
        }
        .btn {
          position: absolute;
          left: 50%;
          margin-left: -229px;
          bottom: 40.33vw;
          width: 458px;
          text-align: center;
          padding: 15px 0;
          background: #ffd768;
          box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.28);
          border-radius: 6px;
          font-size: 24px;
          font-weight: 600;
          color: #d21428;
          line-height: 34px;
          // &.cut-btn {
          //   animation: scaleDraw 2.5s ease-in-out infinite;
          // }
        }
      }
      .content {
        min-height: calc(~'100vh - 807px');
        padding: 10px 24px 100px;
        background: linear-gradient(180deg, #f7c267 0%, #ee7c37 100%);
      }
    }
  }
}
</style>
